import React, { useEffect } from "react";
import { useModel } from "../../../models";
import { Button, message, Table, Upload } from "antd";
import { useHistory } from "react-router";
import { goPage } from "../../layout/pageDefinition";
import WarehouseService from "./WarehouseService";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

const columns = [
    // {
    //     title: '序号',
    //     width: 80,
    //     render: (text, record, index) => `${index + 1}`,
    // },
    {
        title: '公司',
        dataIndex: 'orgName',
    },
    {
        title: '仓库编号',
        dataIndex: 'warehouseCode',
        align: 'left',
    },
    {
        title: '仓库名称',
        dataIndex: 'warehouseName',
    },
    {
        title: '仓库负责人',
        dataIndex: 'warehousePerson',
    },
    {
        title: '电话',
        dataIndex: 'warehousePhone',
    },

    {
        title: '地址',
        dataIndex: 'warehouseAddress',
    },
    {
        title: '备注',
        dataIndex: 'warehouseDesc',
    },
];
export default function () {
    const [
        { warehouseList, selectedWarehouse, warehouseSelectedRowKeys },
        { loadWarehouse, setSelectedWarehouse, setWarehouseSelectedRowKeys }
    ] = useModel("warehouse")
    useEffect(() => {
        loadWarehouse({ showMsg: false, data: { pageSize: 100, pageNum: 1 } });
    }, [])
    const history = useHistory();
    const onAdd = () => {
        goPage(history, "6-2-2");
    }
    const onEdit = () => {
        let findCustomerList = warehouseList.find(item => {
            if (item.key == selectedWarehouse.key) {
                return item
            }
        })
        setSelectedWarehouse(findCustomerList)
        setWarehouseSelectedRowKeys([findCustomerList.key]);
        goPage(history, "6-2-1");
    }

    const onExport = async () => {
        await WarehouseService.export();
    }
    const onDownloadTpl = async () => {
        await WarehouseService.downloadTpl();
    }

    return (
        <>
            <div style={{ margin: "12px 0" }}>
                <YhAuth resCode={ResourceAuthEnum.DATA_W_AD}>
                    <Button type="primary" onClick={onAdd}>新增</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.DATA_W_ED}>
                    <Button className="margin-left-8"
                        onClick={onEdit}
                        disabled={selectedWarehouse == null || selectedWarehouse.length === 0}
                    >
                        编辑
                </Button>
                </YhAuth>
            </div>
            <Table
                columns={columns}
                dataSource={warehouseList}
                bordered
                pagination={false}
                onRow={record => {
                    return {
                        onClick: event => {
                            if (selectedWarehouse && selectedWarehouse.key === record.key) {
                                setSelectedWarehouse(null);
                                setWarehouseSelectedRowKeys([]);
                            } else {
                                setSelectedWarehouse(record);
                                setWarehouseSelectedRowKeys([record.key]);
                            }
                        },
                    };
                }}
                rowSelection={{
                    type: "radio",
                    onChange: (selectedRowKeys, selectedRows) => {
                        console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                        setSelectedWarehouse(selectedRows[0]);
                        setWarehouseSelectedRowKeys(selectedRowKeys);
                    },
                    getCheckboxProps: record => ({
                        disabled: record.name === 'Disabled',
                        name: record.name,
                    }),
                    selectedRowKeys: warehouseSelectedRowKeys,
                }}
                scroll={{ x: 'max-content' }}
            />
        </>
    )
}